import { INotificationRequest } from "@/model/notifications";
import { axiosInstance } from "../instance";
import { AxiosPromise } from "axios";
import { Notification as AppNotification } from "@/model/notifications";

export const getNotifications = (request: INotificationRequest): AxiosPromise<AppNotification[]> => {
    return axiosInstance.get(`/notifications`, { params: request });
}

export const  markViewed = (id: number): AxiosPromise<void> => {
    return axiosInstance.post(`/notification/${id}/mark-viewed`);
}

export const markUnviewed = (id: number): AxiosPromise<void> => {
    return axiosInstance.post(`/notification/${id}/mark-unviewed`);
}

export const markAllViewed = (): AxiosPromise<void> => {
    return axiosInstance.post(`/notification/mark-viewed-all`);
}

export const deleteAllArchive = (): AxiosPromise<void> => {
    return axiosInstance.post(`/notification/delete-viewed-all`);
}